import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Question } from '../../Models/dennysFlow';
import { DisplayLanguage } from '../../Models/DisplayLanguage';

@Component({
  selector: 'app-yes-no',
  templateUrl: './yes-no.component.html',
  styleUrls: ['./yes-no.component.css']
})
export class YesNoComponent implements OnInit {
  @Input() model : boolean;
  @Input() for : string;
  @Input() text : string;
  @Output() updated = new EventEmitter<boolean>();
  @Input() language : DisplayLanguage;

  yesText : string;
  noText : string;
  
  public selected(comparer : boolean) : boolean {
    return this.model == comparer;
  }
  

  constructor() { }
  update(val : boolean){
    this.updated.emit(val);
  }

  modelFlip(val : boolean){
    this.model = val;
    this.update(val); 
  }

  ngOnInit() {
    if(this.language == DisplayLanguage.ENGLISH) {
      this.yesText = 'Yes';
      this.noText = 'No';
    }
    if(this.language == DisplayLanguage.SPANISH) {
      this.yesText = 'Si';
      this.noText = 'No';
    }
  }

}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/utility-components/yes-no/yes-no.component.ts